<template>
  <div class="mm-page-main" v-loading="mso_id==0" :element-loading-text="'請先添加牌照MSO和門店'" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
    <div v-if="customer_id==0" class="page-header">
      <div class="page-title">訂單管理</div>
      <div>
        <el-link @click="gotoruter('/AddOrder')" type="primary"><i class="el-icon-circle-plus"></i>添加訂單</el-link>
      </div>
    </div>
    <search :form="form" @submit="getdata"></search>
    <div style="height:15px"></div>
    <div v-if="stores.length>0" class="mm-tabs">
      <div class="mm-tabsulbox">
        <div @click="tableft" class="tabsleftico"><i class="el-icon-arrow-left"></i></div>
        <ul :style="transform" class="mm-tabs-card">
          <li @click.stop="changestore(0)" :class="{active:store_id == 0}">全部</li>
          <li @click.stop="changestore(store.id)" :class="{active:store_id == store.id}" v-for="(store,index) in stores" :key="index">{{store.short}} {{store.name}}</li>
        </ul>
        <div @click="tabright" class="tabsrightico"><i class="el-icon-arrow-right"></i></div>
      </div>
      <div class="mm-tabs-content">
        <div class="pagemain" v-loading="loading">
          <div class="mainheader" style="padding-top:0;">
            <div class="radio-group-box">
              <div class="radio-group-title">業務類別：</div>
              <div>
                <el-radio-group @change="changeordertype" v-model="form.ordertype">
                  <el-radio-button label="-1">全部</el-radio-button>
                  <el-radio-button label="0">兌換</el-radio-button>
                  <el-radio-button label="1">匯款</el-radio-button>
                  <el-radio-button label="2">內部記賬</el-radio-button>
                </el-radio-group>
              </div>
            </div>
            <div class="downexcel">
              <el-link @click="exportExcel()" icon="el-icon-download">下載EXCEL</el-link>
            </div>
          </div>
          <div class="pagetablebox">
            <el-table :data="data" border :header-cell-style="{background:'#FAFAFA'}">
              <el-table-column width="200" prop="ordernum" label="訂單編號" align="center" >
                <template slot-scope="scope">
                  <div class="phonecel">訂單編號</div>
                  <span :class="{'unlink':scope.row.status==5}" v-if="scope.row.ordertype == 0">{{scope.row.store_short}}-C{{scope.row.ordernum}}</span>
                  <span :class="{'unlink':scope.row.status==5}" v-else-if="scope.row.ordertype == 1">{{scope.row.store_short}}-R{{scope.row.ordernum}}</span>
                  <span :class="{'unlink':scope.row.status==5}" v-else-if="scope.row.ordertype == 2">{{scope.row.store_short}}-I{{scope.row.ordernum}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="ordertype" label="類別" align="center" >
                <template slot-scope="scope">
                  <div class="phonecel">類別</div>
                  <span :class="{'unlink':scope.row.status==5}" v-if="scope.row.ordertype == 0">兌換</span>
                  <span :class="{'unlink':scope.row.status==5}" v-else-if="scope.row.ordertype == 1">匯款</span>
                  <span :class="{'unlink':scope.row.status==5}" v-else-if="scope.row.ordertype == 2">內部記賬</span>
                </template>
              </el-table-column>
              <el-table-column prop="addtime" label="時間" align="center" >
                <template slot-scope="scope">
                  <div class="phonecel">时间</div>
                  <span :class="{'unlink':scope.row.status==5}">{{scope.row.addtime}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="store_name" label="門店" align="center" >
                <template slot-scope="scope">
                  <div class="phonecel">門店</div>
                  <span :class="{'unlink':scope.row.status==5}">{{scope.row.store_name}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="customer_name" label="客戶" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">客戶</div>
                  <el-popover placement="bottom" width="100%" trigger="hover">
                    <div slot="reference">
                      <div :class="{'unlink':scope.row.status==5}">{{scope.row.customer_name==''?'未填寫':scope.row.customer_name}}</div>
                      <div :class="{'unlink':scope.row.status==5}">({{scope.row.customer_phone ==''?'未填寫':scope.row.customer_phone}})</div>
                    </div>
                    <div :class="{'unlink':scope.row.status==5}">
                      <div>類別：{{scope.row.customer_type ==0?'個人':(scope.row.customer_type==1?'企業':'行家')}}</div>
                      <div>{{scope.row.customer_type ==0?'姓名':'公司'}}：{{scope.row.customer_name ==''?'未填寫':scope.row.customer_name}}</div>
                      <div>稱呼：{{scope.row.customer_appellations==0?'其他':(scope.row.customer_appellations==1?'先生':(scope.row.customer_appellations==2?'女士':(scope.row.customer_appellations==3?'小姐':'太太')))}}</div>
                      <div>電話：{{scope.row.customer_phone ==''?'未填寫':scope.row.customer_phone}}</div>
                      <template v-if="scope.row.customer_type==0">
                        <div>地址：{{scope.row.customer_address}}</div>
                      </template>
                      <template v-if="scope.row.customer_type!=0">
                        <div>企業編號：{{scope.row.customer_company_card}}</div>
                      </template>
                      <template v-if="scope.row.customer_type==2">
                        <div>MSO編號：{{scope.row.customer_company_card}}</div>
                      </template>
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column label="買入金額" align="center" >
                <template slot-scope="scope">
                  <div class="phonecel">買入金額</div>
                  <el-popover placement="bottom" width="100%" trigger="hover">
                    <el-table :data="scope.row.buy" border :header-cell-style="{background:'#FAFAFA'}">
                      <el-table-column property="businessnum" width="120" label="交易編號">
                        <template slot-scope="scope">
                          <div class="phonecel">交易編號</div>
                          <span :class="{'unlink':scope.row.status==5}">B{{scope.row.businessnum}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column property="addtime" width="160" label="時間">
                        <template slot-scope="scope">
                          <div class="phonecel">時間</div>
                          <span :class="{'unlink':scope.row.status==5}">{{scope.row.addtime}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column property="account" width="200" label="交易賬戶">
                        <template slot-scope="scope">
                          <div class="phonecel">交易賬戶</div>
                          <div :class="{'unlink':scope.row.status==5}" class="mm-text-right" v-if="scope.row.mode==0">{{scope.row.store_name}} {{scope.row.currency_short_name}}
                            {{scope.row.currency_name}} </div>
                          <div :class="{'unlink':scope.row.status==5}" class="mm-text-right" v-if="scope.row.mode==1">
                            <div v-if="scope.row.bank_account.id">
                              <div>{{scope.row.bank_account.account_name}} {{scope.row.bank_account.account_num}} </div>
                              <div>{{scope.row.bank_account.bankname}} </div>
                              <div>{{scope.row.currency_short_name}} {{scope.row.currency_name}} </div>
                            </div>
                            <div v-else>
                              未關聯賬戶
                            </div>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column label="出款金額" width="120" >
                        <template slot-scope="scope">
                          <div class="phonecel">出款金額</div>
                          <span :class="{'unlink':scope.row.status==5}">
                            {{scope.row.currency_short_name}}
                            {{tomoney(scope.row.money)}}
                          </span>
                        </template>
                      </el-table-column>
                      <el-table-column property="status" label="狀態" >
                        <template slot-scope="scope">
                          <div class="phonecel">狀態</div>
                          <statustext :status="scope.row.status"></statustext>
                        </template>
                      </el-table-column>
                      <!-- <el-table-column property="file" label="水單">
                    <template slot-scope="scope">
                      <img src="@/assets/logo.png" height="40" />
                    </template>
                  </el-table-column> -->

                    </el-table>
                    <div style="padding:10px 0">
                      總數: {{scope.row.buy.length}} 筆交易，折合港幣 {{tomoney(get_hkd_total(scope.row.buy))}}HKD。
                    </div>
                    <div slot="reference">
                      <div :class="{'unlink':scope.row.status==5}" v-for="(buy,bk) in scope.row.buy" :key="bk">{{buy.currency_short_name}} {{tomoney(buy.money)}}</div>
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column label="進度" align="center" >
                <template slot-scope="scope">
                  <div class="phonecel">進度</div>
                  <div v-if="scope.row.buy.length>0">
                    <statustext :status="scope.row.buystatus"></statustext>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="賣出金額" align="center" >
                <template slot-scope="scope">
                  <div class="phonecel">賣出金額</div>
                  <el-popover placement="bottom" width="100%" trigger="hover">
                    <el-table :data="scope.row.sell" border :header-cell-style="{background:'#FAFAFA'}">
                      <el-table-column property="businessnum" width="120" label="交易編號">
                        <template slot-scope="scope">
                          <div class="phonecel">交易編號</div>
                          <span :class="{'unlink':scope.row.status==5}">S{{scope.row.businessnum}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column property="addtime" width="160" label="時間">
                        <template slot-scope="scope">
                          <div class="phonecel">時間</div>
                          <span :class="{'unlink':scope.row.status==5}">{{scope.row.addtime}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column property="account" width="200" label="交易賬戶">
                        <template slot-scope="scope">
                          <div class="phonecel">交易賬戶</div>
                          <div :class="{'unlink':scope.row.status==5}" v-if="scope.row.mode==0">{{scope.row.store_name}} {{scope.row.currency_short_name}}
                            {{scope.row.currency_name}} </div>
                          <div :class="{'unlink':scope.row.status==5}" v-if="scope.row.mode==1">
                            <div v-if="scope.row.bank_account.id">
                              <div>{{scope.row.bank_account.account_name}} {{addSpace(scope.row.bank_account.account_num)}} </div>
                              <div>{{scope.row.bank_account.bankname}} </div>
                              <div>{{scope.row.currency_short_name}} {{scope.row.currency_name}} </div>
                            </div>
                            <div v-else>
                              未關聯賬戶
                            </div>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column label="出款金額" width="120">
                        <template slot-scope="scope">
                          <div class="phonecel">出款金額</div>
                          <span :class="{'unlink':scope.row.status==5}">
                            {{scope.row.currency_short_name}}
                            {{tomoney(scope.row.money)}}
                          </span>
                        </template>
                      </el-table-column>
                      <el-table-column property="status" label="狀態">
                        <template slot-scope="scope">
                          <div class="phonecel">狀態</div>
                          <statustext :status="scope.row.status"></statustext>
                        </template>
                      </el-table-column>
                      <!-- <el-table-column property="file" label="水單">
                        <div class="phonecel">水單</div>
                        <template slot-scope="scope">
                          <img src="@/assets/logo.png" height="40" />
                        </template>
                      </el-table-column> -->
                    </el-table>
                    <div style="padding:10px 0">
                      總數: {{scope.row.sell.length}} 筆交易，折合港幣 {{tomoney(get_hkd_total(scope.row.sell))}}HKD。
                    </div>
                    <div slot="reference">
                      <div :class="{'unlink':scope.row.status==5}" v-for="(sell,bk) in scope.row.sell" :key="bk">{{sell.currency_short_name}} {{tomoney(sell.money)}}</div>
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column prop="sellstatus" label="進度" align="center" >
                <template slot-scope="scope">
                  <div class="phonecel">進度</div>
                  <div v-if="scope.row.sell.length>0">
                    <statustext :status="scope.row.sellstatus"></statustext>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="狀態" align="center" >
                <template slot-scope="scope">
                  <div class="phonecel">狀態</div>
                  <orderstatustext :status="scope.row.status"></orderstatustext>
                </template>
              </el-table-column>
              <el-table-column prop="remarks" label="備註" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">備註</div>
                    <div>{{scope.row.	remarks}}</div>
                  </template>
                </el-table-column>
              <el-table-column label="開單員" width="120" >
                <template slot-scope="scope">
                  <div class="phonecel">開單員</div>
                  <span :class="{'unlink':scope.row.status==5}">
                    {{scope.row.username}}
                    ({{scope.row.operator}})
                  </span>
                </template>
              </el-table-column>
              <!-- <el-table-column property="file" label="水單">
                <template slot-scope="scope">
                  <div v-if="scope.row.files.length>0" class="flex">
                    <img :src="apiurl+scope.row.files[0].fileurl" height="35px" class="mr10" @click="showimg_url=apiurl+scope.row.files[0].fileurl;showimg_dialog = true;">
                    <el-link v-if="scope.row.files.length>1" @click="Details(scope.row.id)">還有{{scope.row.files.length-1}}張</el-link>
                  </div>
                </template>
              </el-table-column> -->
              <el-table-column prop="status" label="操作" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">操作</div>
                  <el-link @click="Details(scope.row.id)"><i class="el-icon-circle-plus-outline"></i>詳細</el-link>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div class="page-bottom">
            <div class="footerbox">
              <div class="stat-box">
                <div class="stat-item">
                  <svg class="icon svg-icon" aria-hidden="true">
                    <use xlink:href="#icon-huobi"></use>
                  </svg>
                  總金額 {{tomoney(totaldata.total_money-totaldata.total_fee)}} HKD
                </div>
                <div class="stat-item">
                  總手續費 {{tomoney(totaldata.total_fee)}} HKD
                </div>
                <div class="stat-item">
                  總利潤 {{tomoney(totaldata.total_profits)}} HKD
                </div>
              </div>
              <div class="stat-box">
                <div class="stat-item"><i class="el-icon-pie-chart"></i> 總筆數：{{totaldata.total_num}} 筆</div>
                <div class="stat-item"> Pending：{{totaldata.total_pending}} 筆</div>
                <div class="stat-item"> Approved：{{totaldata.total_approved}} 筆</div>
                <div class="stat-item"> Processing：{{totaldata.total_processing}} 筆</div>
                <div class="stat-item"> Successful：{{totaldata.total_success}} 筆</div>
                <div class="stat-item"> Failed：{{totaldata.total_failed}} 筆</div>
                <div class="stat-item"> Delete：{{totaldata.total_delete}} 筆</div>
              </div>
            </div>
            <div class="pagebox">
              <div>
                <el-pagination background @size-change="changesize" @current-change="changepage" :current-page="pager.p_now" :page-sizes="[5, 10, 20, 50]" :page-size="parseInt(pager.p_size)" layout="sizes, prev, pager, next, jumper" :total="pager.p_count">
                </el-pagination>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- 水單查看 -->
    <el-dialog :visible.sync="showimg_dialog" height="80%" center top="5vh" :append-to-body="true">
      <img :src="showimg_url" alt="" style="width:100%;margin:0 auto;">
    </el-dialog>

    

  </div>
</template>

<script>
import search from "./components/Search.vue";
import statustext from "@/components/StatusText.vue";
import orderstatustext from "@/components/OrderStatusText.vue";

import XLSX from 'xlsx';
export default {
  components: {
    search,
    statustext,
    orderstatustext,
  },
  props: {
    customer_id: {
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
      showimg_url: '',
      showimg_dialog: false,
      mso_id: 0,
      store_id: 0,
      stores: [],
      transform: '',
      transformnum: 0,
      loading: true,
      form: {
        ordertype: -1,
        mode: '',
        currency_id: "-1",
        status: '-1',
        startmoney: '',
        endmoney: '',
        starttime: '',
        endtime: '',
        ordernum: '',
        staff_id: '-1',
        customer_type: '-1',
        customer_name: '',
        sortname: 'addtime',
        orderby: 'DESC',
      },
      data: [],
      page: 1,
      pagesize: 10,
      pager: [],
      totaldata: [],
    };
  },
  methods: {
    exportExcel () {
      this.$confirm("確認下載EXCEL嗎？", '詢問', {
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.excel();
      }).catch(error => {
        console.log(error);
      });
    },
    excel () {
      let form = this.form;
      this.post('/api/order/index', {
        export_excel: 1,
        page: this.page,
        pagesize: this.pagesize,
        store_id: this.store_id,
        ...form
      }).then(response => {
        if (response.info.length > 0) {
          this.createExcel(response.info);
        } else {
          // 提醒信息
          this.$notify({
            message: '暫無相關數據',
            type: 'error',
            duration: 3000,
            offset: 160
          });
        }
      }).catch(error => { console.log(error) });
      return false;

    },
    createExcel (data) {
      //数据表格
      var table = [];
      table.push({
        A: "單號",
        B: "日期",
        C: "客戶名稱",
        D: "客戶電話",
        E: "買入金額",
        F: "買入貨幣",
        G: "賣出金額",
        H: "賣出貨幣",
        I: "匯率",
        J: "手續費",
        K: "手續費貨幣",
        L: "狀態",
      });
      data.forEach(function (item) {
        var row = {
          A: item.ordernum,
          B: item.addtime,
          C: item.customer_name,
          D: item.customer_phone,
          E: item.buy_money,
          F: item.buy_currency,
          G: item.sell_money,
          H: item.sell_currency,
          I: item.rate,
          J: item.fee_money,
          K: item.fee_currency,
          L: item.status,

        };
        table.push(row);
      });
      //创建book
      var wb = XLSX.utils.book_new();
      //json转sheet
      var ws = XLSX.utils.json_to_sheet(table, { header: ["A", "B", "C", "D", "E", "F", "G", "H", "I"], skipHeader: true });
      //设置列宽
      ws['!cols'] = [
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 10 }
      ];
      var timestamp = (new Date()).getTime();
      //sheet写入book
      XLSX.utils.book_append_sheet(wb, ws, "訂單列表");
      //输出
      XLSX.writeFile(wb, "orderlist" + timestamp + ".xlsx");
    },
    tableft () {
      let num = this.transformnum - 1;
      if (num >= 0) {
        this.transform = 'transform:translate3d(' + (-85 * num) + 'px,0,0)';
        this.transformnum = num;
      }

    },
    tabright () {
      let num = this.transformnum + 1;
      if (num < this.stores.length - 1) {
        this.transform = 'transform:translate3d(' + (-85 * num) + 'px,0,0)';
        this.transformnum = num;
      }
    },
    get_hkd_total (data) {
      if (data.length == 0) {
        return 0;
      } else {
        let total = 0;
        data.map(item => {
          total += parseFloat(item.hkd);
        });
        return total.toFixed(2);
      }
    },
    gotoruter (name) {
      this.$router.push(name)
    },
    changeordertype () {
      this.getdata();
    },
    changepage (val) {
      this.page = val;
      this.getdata();
    },
    changesize (val) {
      this.pagesize = val;
      this.getdata();
    },
    getdata () {
      this.loading = true;
      let form = this.form;
      this.post('/api/order/index', {
        page: this.page,
        pagesize: this.pagesize,
        store_id: this.store_id,
        ...form
      }).then((res) => {
        this.loading = false;
        if (res.status == 'success') {
          if (res.info.length > 0) {
            this.pager = res.pager;
            this.data = res.info;
            this.totaldata = res.totaldata;
            this.page = 1;
          } else {
            this.pager = [];
            this.data = [];
            this.totaldata = [];
          }
        } else {
          this.pager = [];
          this.data = [];
          this.totaldata = [];
        }
      }).catch((err) => {
        this.loading = false;
        console.log(err)
      })
    },
    getstore () {

      this.post('/api/store/index', {

      }).then((res) => {
        this.stores = res;
      }).catch((err) => {

        console.log(err)
      }).then(() => {
        this.getdata();
      })


    },
    changestore (store_id) {
      this.store_id = store_id;
      this.getdata();
    },
    Details (id) {

      this.$router.push({
        name: '/OrderDetails',
        path: '/OrderDetails',
        query: {
          id: id
        }
      })
    }

  },
  created () {
    this.mso_id = this.sessionRead('mso_id');
    this.getstore();
  },
  watch: {
    'form': { // 動態監控利率變化
      handler: function (val) {
        this.getdata();
      },
      deep: true
    },
  }
};
</script>
<style scoped>
.mainheader {
  padding-top: 20px;
}

.pagetablebox {
  padding: 20px 0;
}

.total-info {
  padding: 20px 0;
}

.radio-group-box {
  display: flex;
  align-items: center;
}

.successmark {
  display: inline-block;
  height: 18px;
  line-height: 18px;
  width: 18px;
  background-color: rgb(103, 194, 58);
  color: #fff;
}

.stat-box {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin: 15px 0;
}

.stat-item {
  margin-right: 15px;
  font-size: 14px;
  font-weight: 500;
}

@media screen and (max-width: 1024px) {
  .footerbox {
    padding-bottom: 10px;
  }

  .stat-box {
    display: flex;
    margin: 0;
    justify-content: space-between;
    padding: 5px 0;
  }

  .stat-item {
    flex: 1 1 49%;
    margin: 0;
  }

  .stat-item:nth-child(even) {
    text-align: right;
  }

  .pagebox {
    margin: 0 auto;
  }
}
</style>
